module.exports = __webpack_public_path__ + "static/media/fireking.7f252291.jpg";